module.exports = __webpack_public_path__ + "media/icons/sprowadzony-grey@2x-3a063176.png";